import { useEffect, useMemo, useState } from "react";

import { ValidViews } from "../../../OrderOptionsModalInner";
import { ViewInfo } from "../../types";

export const useViewInfo = (initialView: ValidViews): ViewInfo => {
  const [view, setView] = useState<ValidViews>(initialView);

  useEffect(() => {
    //Resetting view once modal is closed then reopened
    setView(initialView);
  }, [initialView]);

  return useMemo(
    () => ({
      initial: initialView,
      view,
      set: setView,
    }),
    [initialView, view]
  );
};
